import React, { useContext } from 'react';
import ContentBox from 'Components/common/ContentBox/ContentBox';
import { AppContext } from 'App.context';
import JoditEditor from 'jodit-react';
import SaveButton from 'Components/common/SaveButton/SaveButton';
import styles from '../DefaultInfoTexts.styles';
import Colors from 'constants/Colors';
import AppButton from 'Components/common/Forms/AppButton/AppButton';
import { EyeFilled } from '@ant-design/icons';
import sanitizeHtml from 'utils/sanitizeHtml';

export default function StartCheckinText({ state, actions }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const config = {
    placeholder: '',
    height: 300,
    toolbarAdaptive: false,
    removeButtons: ['fullsize', 'print', 'dots', 'copyformat', 'image'],
    showCharsCounter: false,
    showWordsCounter: false,
    cleanHTML: { fillEmptyParagraph: false },
  };

  return (
    <>
      <ContentBox noPadding title={translate('informationTexts.startCheckin')}>
        <JoditEditor
          value={state.startCheckinText || ''}
          config={config}
          onBlur={val => actions.handleEditorChange(val, 'startCheckinText')}
        />
        <div style={styles.previewButton}>
          <AppButton
            secondary
            //action={} no action needed
            text={translate('legalDocuments.previewBtn')}
            icon={<EyeFilled style={{ color: '#708393' }} />}
            style={{
              alignSelf: 'flex-end',
            }}
          />
        </div>
        <div style={styles.saveButtonContainer}>
          <SaveButton
            action={applyToAll =>
              actions.onSavePressed('start-checkin', state.startCheckinText, applyToAll)
            }
            text={translate('save')}
          />
        </div>
      </ContentBox>

      <ContentBox noPadding title={translate('legalDocuments.preview')}>
        <div style={styles.checkinFields}>
          <div style={{ color: Colors.darkText }}>
            <strong>{translate('informationTexts.bookingNumber')}</strong>
            <span style={{ marginLeft: 8 }}>6952234132179</span>
          </div>
          <div style={{ color: Colors.darkText }}>
            <strong>{translate('informationTexts.guestName')}</strong>
            <span style={{ marginLeft: 8 }}>Guest</span>
          </div>
          <div style={{ color: Colors.darkText }}>
            <strong>{translate('informationTexts.entryDate')}</strong>
            <span style={{ marginLeft: 8 }}>30/06/2025</span>
          </div>
        </div>
        <div
          style={{ marginTop: '1%', width: '100%' }}
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(state.startCheckinText) }}
        />
        <div style={styles.checkinFields}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              color: Colors.darkText,
            }}
          >
            <strong>Guest</strong>
          </div>
        </div>
      </ContentBox>
    </>
  );
}
